module.exports = __webpack_public_path__ + "static/kakoon-logo-white-compressed-d8ca3305e4f5248720e02b0ee42dc5b3.png";